var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSend = function SvgSend(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4775 19.425L19.8083 13.3655C20.9806 12.8326 20.9806 11.1674 19.8082 10.6344L6.4775 4.57501C5.25567 4.01964 3.97528 5.22555 4.45655 6.47844L6.57753 12L4.45655 17.5216C3.97528 18.7744 5.25566 19.9804 6.4775 19.425ZM19.1875 12L5.85679 18.0594L7.76006 13.1047L12.7346 12.1473C12.8968 12.1161 12.8968 11.8839 12.7346 11.8527L7.76006 10.8953L5.85679 5.94056L19.1875 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4775 19.425L19.8083 13.3655C20.9806 12.8326 20.9806 11.1674 19.8082 10.6344L6.4775 4.57501C5.25567 4.01964 3.97528 5.22555 4.45655 6.47844L6.57753 12L4.45655 17.5216C3.97528 18.7744 5.25566 19.9804 6.4775 19.425ZM19.1875 12L5.85679 18.0594L7.76006 13.1047L12.7346 12.1473C12.8968 12.1161 12.8968 11.8839 12.7346 11.8527L7.76006 10.8953L5.85679 5.94056L19.1875 12Z",
    fill: "currentColor",
    fillOpacity: 0.2
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "send.b3404d4ae9809168a76e4a3669b89ae1.svg";